export default "__VITE_ASSET__3197b8f9__"